import { COLOR1, COLOR2, COLOR3, GRAY44 } from '../../../constants';

export const FundingScreenStyles = {
  readMore: {
    display: 'block',
    textDecoration: 'none',
    color: '#661C69',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },

  outerDiv: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: '30px',
    marginBottom: '17px',
    marginRight: '14px',
  },

  outerDivAnother: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: '20px',
    marginBottom: '47px',
    marginRight: '16px',
    '@media(max-width:600px)': {
      marginTop: '10px',
      marginBottom: '28px',
      marginRight: '0px',
    },
  },

  imgDivDesign: {
    width: '24px',
    height: '24px',
    marginRight: '13px',
  },

  mainHeading: {
    color: '#661C69',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '20px',
    marginBottom: '18px',
  },

  subHeading: {
    color: '#000000',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '10px',
  },

  chkAccountHeading: {
    color: '#000000',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '10px',
  },

  fund_stepper: {
    width: '100%',
    margin: '37px 30px 40px 50px',
    '@media(max-width:600px)': {
      margin: '37px 50px 45px 50px',
    },
    '@media(max-width:650px)': {
      margin: '25px',
    },
  },

  toggleStyle: {
    marginBottom: '10px',
    '@media(max-width:960px)': {
      marginBottom: '10px',
    },
    '@media(max-width:600px)': {
      marginBottom: '0px',
    },
  },

  disableSwitch: {
    cursor: 'unset !important',
  },

  input_grid_padding: {
    '@media(max-width:600px)': {
      marginBottom: '10px',
    },
  },

  gridSpace: {
    marginTop: '20px',
  },

  gridBorder: {
    paddingTop: '30px',
    display: 'grid',
    width: 'inherit',
    borderTop: '1px solid #E6E6E6',
    '@media(max-width:650px)': {
      marginTop: '10px',
      paddingTop: '20px',
    },
  },

  radioRoot: {
    width: 0,
    height: '19px',
    paddingTop: 0,
    paddingBottom: 0,
    color: '#661c69',
  },

  radioLabelStyle: {
    marginLeft: '8px',
    marginRight: '20px',
    font: 'normal 700 16px/19px Arial',
    color: '#000000',
    cursor: 'pointer',
    '@media(max-width:600px)': {
      font: '700 16px/18px Arial',
    },
  },

  toggleGridStyle: {
    marginTop: '38px',
    marginBottom: '10px',
    '@media(max-width:600px)': {
      marginTop: '20px',
    },
  },

  radio_text: {
    font: 'normal 700 16px/18px Arial',
    color: '#661C69',
    '@media(max-width:600px)': {
      marginBottom: '10px',
    },
  },

  oriLabel: {
    marginRight: '7px',
    font: 'normal 700 16px/18px Arial',
    color: '#000000',
    '@media(max-width:600px)': {
      marginRight: '15px',
    },
  },

  fund_grid_margin: {
    background: '#FFFFFF',
    border: '1px solid #D0D0D0',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 21%)',
    borderRadius: '6px',
    paddingTop: '25px',
    paddingRight: '30px',
    paddingBottom: '35px',
    paddingLeft: '30px',
    opacity: 1,
    '@media (min-width:601px) and (max-width:1200px)': {
      paddingTop: '25px',
      paddingRight: '25px',
      paddingBottom: '25px',
      paddingLeft: '30px',
    },
    '@media(max-width:600px)': {
      border: 'none',
      boxShadow: 'none',
      borderRadius: '0px',
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
  },

  fund_container: {
    padding: '20px',
    background: `${COLOR3} 0% 0% no-repeat padding-box`,
    border: `.25px solid ${GRAY44}`,
    borderRadius: '10px',
    opacity: 1,
    marginBottom: '20px',
    '@media(max-width:960px)': {
      padding: '20px 25px',
    },
  },

  fund_container_oriental: {
    background: '#FFFFFF',
    border: '1px solid #D0D0D0',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 21%)',
    borderRadius: '6px',
    padding: '25px 30px 0px',
    opacity: 1,
    '@media(max-width:1200px)': {
      padding: '25px 25px 0px',
    },
  },

  statement_upload_style_adjust: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingLeft: '10px',
    '@media(max-width:960px)': {
      marginTop: '10px',
    },
    '@media(max-width:600px)': {
      paddingLeft: '0',
    },
  },

  statement_upload_text_desc: {
    font: 'normal normal 300 16px/18px Arial',
    letterSpacing: '0.11px',
    width: '218px',
    marginTop: '20px',
    opacity: '0.8',
    marginBottom: '10px',
    '@media(max-width:320px)': {
      width: 'auto',
    },
  },

  fund_heading: {
    textAlign: 'left',
    width: 'fit-content',
    font: 'normal normal bold 20px/23px Arial !important',
    letterSpacing: '0.14px',
    opacity: 1,
    '@media(max-width:650px)': {
      font: 'normal normal bold 16px/18px Arial !important',
      letterSpacing: '0.11px',
      margin: '0',
      marginBottom: '5px',
    },
    '@media(max-width:600px)': {
      font: 'normal 700 22px/32px Arial !important',
      marginBottom: '0px',
      marginTop: '-10px',
    },
  },

  fund_heading_bundle: {
    textAlign: 'left',
    width: 'fit-content',
    font: 'normal normal 700 16px/100% TTNormsProBold !important',
    letterSpacing: '0px',
    opacity: 1,
  },

  inputs_grid_margin: {
    marginTop: '10px',
    marginBottom: '10px',
    width: '100%',
    // '@media(max-width:950px)': {
    //   marginTop: '10px',
    //   marginBottom: '0',
    //   width: '100%',
    // },
  },

  inputs_grid_margin_another: {
    marginTop: '10px',
    marginBottom: '10px',
    '@media(max-width:950px)': {
      marginTop: '10px',
      marginBottom: '10px',
    },
  },

  margin_adjust_for_top_grid: {
    marginTop: '21px',
    '@media(max-width:960px)': {
      marginTop: '20px',
    },
  },

  field_padding_right: {
    paddingRight: '25px',
    width: '100%',
    // '@media(max-width:960px)': {
    //   // paddingRight: '0',
    //   width: '100%',
    // },
  },

  field_padding_left: {
    paddingLeft: '25px',
    '@media(max-width:960px)': {
      paddingLeft: '0',
    },
  },

  field_padding_oriental: {
    paddingRight: '20px',
    '@media(max-width:960px)': {
      paddingRight: '0',
    },
  },
  field_padding_oriental_bundle: {
    paddingRight: '0px',
    '@media(max-width:960px)': {
      paddingRight: '0',
    },
  },

  field_padding_oriental_DGI: {
    paddingRight: '25px',
    '@media(max-width:960px)': {
      paddingRight: '0',
    },
  },

  toggle_mobile_top: {
    '@media(max-width:550px)': {
      display: 'block',
      width: '100%',
      maxWidth: '100%',
      flexBasis: '100%',
    },
    '@media(between(550,600))': {
      maxWidth: '50%',
    },
  },

  resp_margin: {
    marginLeft: '20px',
    '@media(max-width:991px)': {
      marginLeft: 0,
    },
  },

  switch_toggle: {
    margin: '25px 0 0',
    '@media(min-width:1300px)': {
      maxWidth: '75%',
      flexBasis: '75%',
    },
    '@media(max-width:550px)': {
      maxWidth: '100%',
      flexBasis: '100%',
    },
    '& .MuiFormControl-root': {
      display: 'block',
      width: '100%',
    },
    '& .MuiFormControlLabel-root': {
      display: 'flex',
      justifyContent: 'flex-end',
      '@media(max-width:550px)': {
        justifyContent: 'space-between',
      },
    },
  },

  switch_toggle_top: {
    '& toggle_mobile_top:nth-child(1) .MuiFormControlLabel-root div': {
      marginLeft: '15px',
    },
  },

  align_toggle_btn: {
    '@media (min-width:850px) and (max-width:960px)': {
      maxWidth: '30%',
    },
    '@media (min-width:750px) and (max-width:850px)': {
      maxWidth: '35%',
    },
    '@media (min-width:700px) and (max-width:750px)': {
      maxWidth: '40%',
    },
  },

  toggle_mobile_debitcard: {
    '& .MuiFormControlLabel-root div': {
      marginLeft: '40px',
      '@media(max-width:800px)': {
        marginLeft: '0px',
      },
    },
  },
  fund_button_container: {
    '@media(max-width:650px)': {
      justifyContent: 'center',
      display: 'flex',
    },
  },

  radioStyle: { marginTop: '10px', marginBottom: '30px', display: 'inline-flex' },
  fundingFlex: { display: 'flex', alignItems: 'center' },

  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  label_formControl: {
    marginLeft: '2px',
    font: 'normal normal 300 16px/18px Arial',
    letterSpacing: '0.11px',
    color: COLOR1,
    opacity: 1,
    textAlign: 'left',
  },

  id_upload_module_grid: {
    marginTop: '55px',
    '@media(max-width:960px)': {
      maxWidth: 'none',
      marginTop: '10px',
      marginBottom: '20px',
    },
    '@media(max-width:650px)': {
      marginTop: '20px',
      marginBottom: '20px',
    },
  },

  switch_toggle_second: {
    marginTop: '25px',
  },

  consent_message: {
    marginTop: '20px',
    marginBottom: '26px',
    '@media(max-width:960px)': {
      marginBottom: '5px',
    },
  },

  consent_fund_orientalDgi: {
    marginTop: '35px',
    marginBottom: '-31px',
    '@media(max-width:960px)': {
      marginBottom: '5px',
    },
  },

  consent_fund_oriental: {
    marginBottom: '-31px',
    '@media(max-width:960px)': {
      marginBottom: '5px',
    },
  },

  contact_terms: {
    font: 'normal 400 14px/16px Arial',
    color: COLOR1,
    opacity: 1,
    letterSpacing: '0.1px',
    '@media(max-width:600px)': {
      font: '400 16px/18px Arial',
    },
  },
  depositHeading: {
    fontSize: '16px',
    fontWeight: 700,
    paddingBottom: '20px',
  },
};
